<template>
	<div class="image-gallery">
		<vue-gallery v-if="!selectable" :images="images" :index="index" @close="index = null"/>

		<div class="row q-col-gutter-md">
			<div v-for="(image, imageIndex) in images" :class="gallerySizeClasses" class="relative-position">
				<q-img :key="imageIndex" :src="image" @click="onImageClick(imageIndex)" ratio="1" style="background-color: var(--image-placeholder-color);"/>
				<slot name="imageActions" :image="image" :imageIndex="imageIndex"/>
			</div>
		</div>
	</div>
</template>

<script>
	import VueGallery from 'vue-gallery';

	export default {
		name: "VeneerLogImages",
		components: {VueGallery},
		props: {
			images: Array,
			selectable: {
				type: Boolean,
				default: false
			},
			large: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				index: null
			}
		},
		computed: {
			gallerySizeClasses() {
				return this.large ? 'col-12 col-sm-6 col-md-3' : 'col-12 col-sm-6 col-md-4';
			}
		},
		methods: {
			onImageClick(imageIndex) {
				if (this.selectable) {
					this.$emit('select-image', imageIndex);
				} else {
					this.index = imageIndex;
				}
			}
		}
	}
</script>